function initCustomerAddressScripts() {


  // Pre-load provinces for any modal already in DOM
  document.querySelectorAll('modal-dialog').forEach(modal => {
    if ((modal.id === 'AddAddressModal' || modal.id.startsWith('EditAddressModal')) && !modal._provincesLoaded) {
      loadProvinces(modal);
      modal._provincesLoaded = true;
    }
  });

  // Attach modal opening listeners
  document.querySelectorAll('modal-opener').forEach((opener) => {
    if (opener._listenerAdded) return;
    opener.addEventListener('click', async () => {
      const target = document.querySelector(opener.dataset.modal);
      if (!target) return;

      target.classList.remove('hidden');
      document.body.classList.add('modal-opener');

      // Attach dropdown listeners every time the modal opens
      attachDropdownListeners(target);
      
      // Ensure provinces and cascade logic are triggered on open
      loadProvinces(target);
      
      // Sync labels when modal opens
      refreshLabels(target);
    });
    opener._listenerAdded = true;
  });

  document.querySelectorAll('modal-dialog .edit-close').forEach((btn) => {
    if (btn._listenerAdded) return;
    btn.addEventListener('click', () => {
      const modal = btn.closest('modal-dialog');
      modal.classList.add('hidden');
      document.body.classList.remove('modal-opener', 'overflow-hidden');
      modal?.removeAttribute('open');

      if (modal.id === 'AddAddressModal' || modal.id.startsWith('EditAddressModal')) {
        const addressForm = modal.querySelector('form[action*="/account/addresses"]');
        if (addressForm) {
          addressForm.reset();
          
          // Clear dropdowns and set to disabled
          addressForm.querySelector('select[name="address[city]"]')?.setAttribute('disabled', true);
          addressForm.querySelector('select[name="address[district]"]')?.setAttribute('disabled', true);
          
          // Clear all visual states
          modal.querySelectorAll('label.has-value').forEach((lbl) => lbl.classList.remove('has-value'));
          modal.querySelectorAll('.field.has-error').forEach((fld) => fld.classList.remove('has-error'));
          modal.querySelectorAll('.field-login.has-error').forEach((fld) => fld.classList.remove('has-error'));
          modal.querySelectorAll('[aria-invalid]').forEach((el) => el.setAttribute('aria-invalid', 'false'));
          
          // Remove all error messages
          modal.querySelectorAll('.error-message-field').forEach((err) => err.remove());
          modal.querySelector('.global-error-bar')?.remove();
        }
      }
    });
  });

  // Attach postal code restriction
  document.querySelectorAll('input[name="address[zip]"]').forEach((postalInput) => {
    if (postalInput._listenerAdded) return;
    postalInput.addEventListener('input', () => {
      postalInput.value = postalInput.value.replace(/\D/g, '').slice(0, 4);
    });
    postalInput._listenerAdded = true;
  });

  // Global Floating Labels delegation
  if (!document._floatingLabelListenerAdded) {
    document.addEventListener('change', (e) => {
      if (e.target.matches('.field__input, .field select')) {
        updateLabelState(e.target);
      }
    }, true);
    
    document.addEventListener('focus', (e) => {
      if (e.target.matches('.field__input, .field select')) {
        e.target.closest('.field')?.classList.add('field--is-focused');
      }
    }, true);

    document.addEventListener('blur', (e) => {
      if (e.target.matches('.field__input, .field select')) {
        e.target.closest('.field')?.classList.remove('field--is-focused');
        updateLabelState(e.target);
      }
    }, true);
    
    document._floatingLabelListenerAdded = true;
  }

  // Initial sync
  refreshLabels();
}

/**
 * Syncs the floating label state for all fields in a container
 */
function refreshLabels(container = document) {
  container.querySelectorAll('.field .field__input, .field select').forEach(element => {
    updateLabelState(element);
  });
}

/**
 * Standardizes the floating label state for a select/input on its parent container
 */
function updateLabelState(element) {
  if (!element) return;
  const fieldContainer = element.closest('.field');
  if (!fieldContainer) return;

  const value = element.value ? element.value.trim() : '';
  const hasValue = value !== '';

  if (hasValue) {
    fieldContainer.classList.add('field--has-value');
  } else {
    fieldContainer.classList.remove('field--has-value');
  }
}

/**
 * Collects values from the address form
 */
function getFormValues(form) {
  const formData = new FormData(form);
  const values = {};
  for (let [key, value] of formData.entries()) {
    values[key] = value.trim();
  }
  return values;
}

/**
 * Synchronizes custom address fields (District) to customer metafields via Bridge API
 */
async function syncAddressMetafields(form) {
  if(!window.customer?.email){
    return;
  }
  const formData = getFormValues(form);
  const provinceSelect = form.querySelector('select[name="address[province]"]');
  const citySelect = form.querySelector('select[name="address[city]"]');
  const districtSelect = form.querySelector('select[name="address[district]"]');
  
  const shopifyAddressId = form.querySelector('[shopify-address-id]')?.getAttribute('shopify-address-id') || "";

  const payload = {
    shop: window.ShopifyStoreDomain,
    email: window.customer.email,
    shopifyAddressId: shopifyAddressId,
    address: {
      firstName: formData['address[first_name]'] || '',
      lastName: formData['address[last_name]'] || '',
      address1: formData['address[address1]'] || '',
      address2: formData['address[address2]'] || '',
      countryCode: 'PH',
      province: provinceSelect?.value || '',
      provinceCode: provinceSelect?.options[provinceSelect.selectedIndex]?.dataset?.code || '',
      city: citySelect?.value || '',
      district: districtSelect?.value || '',
      zip: formData['address[zip]'] || '',
    }
  };

  try {
    const endpoints = window.API_CONFIG?.ENDPOINTS || {};
    const res = await fetch(`${window.API_CONFIG.BASE_URL}${endpoints.ADDRESS_SAVE}`, {
      method: 'POST',
      headers: window.API_CONFIG?.HEADERS || { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    return await res.json();
  } catch (err) {
    // Fail silently to ensure form submission continues
  }
}

function attachDropdownListeners(targetModal) {
  const provinceDropdown = targetModal.querySelector('select[name="address[province]"]');
  const cityDropdown = targetModal.querySelector('select[name="address[city]"]');

  if (provinceDropdown && !provinceDropdown._listenerAdded) {
    provinceDropdown.addEventListener('change', async (e) => {
      const provinceName = e.target.value;

      resetDropdown(targetModal.querySelector('select[name="address[city]"]'));
      resetDropdown(targetModal.querySelector('select[name="address[district]"]'));

      if (!provinceName) return;
      await getCitiesByProvince(targetModal, provinceName);
    });
    provinceDropdown._listenerAdded = true;
  }

  if (cityDropdown && !cityDropdown._listenerAdded) {
    cityDropdown.addEventListener('change', async (e) => {
      const cityName = e.target.value;
      const provinceName = provinceDropdown?.value || '';

      resetDropdown(targetModal.querySelector('select[name="address[district]"]'));

      if (!provinceName || !cityName) return;
      await getDistrictsByCity(targetModal, provinceName, cityName);
    });
    cityDropdown._listenerAdded = true;
  }
}

let provincesPromise = null;

async function loadProvinces(targetModal) {
  const provinceDropdown = targetModal.querySelector('select[name="address[province]"]');
  if (!provinceDropdown) return;

  const selectedProvince = provinceDropdown.dataset.selected || '';
  const cityDropdown = targetModal.querySelector('select[name="address[city]"]');
  const districtDropdown = targetModal.querySelector('select[name="address[district]"]');

  // Skip if already loading to prevent race conditions
  if (provinceDropdown.getAttribute('disabled') === 'true' && provinceDropdown.classList.contains('is-fetching')) return;

  setLoadingState(targetModal, true);
  provinceDropdown.setAttribute('disabled', 'true');
  provinceDropdown.classList.add('is-fetching');

  try {
    if (!provincesPromise) {
      const endpoints = window.API_CONFIG?.ENDPOINTS || {};
      const endpoint = endpoints.ADDRESS_PROVINCES || '/api/locations/provinces';
      const baseUrl = window.API_CONFIG.BASE_URL || '';

      provincesPromise = fetch(`${baseUrl}${endpoint}`, {
        method: 'GET',
        headers: window.API_CONFIG?.HEADERS || { 'Content-Type': 'application/json' },
      })
      .then(res => res.json())
      .then(json => Array.isArray(json) ? json : (json?.data || []))
      .catch(err => {
        provincesPromise = null;
        throw err;
      });
    }

    const provinces = await provincesPromise;
    let options = '<option value="" selected disabled hidden></option>';
    let resolvedProvinceName = '';

    if (provinces.length === 0) {
      options = '<option value="" disabled>No provinces found</option>';
    } else {
      provinces.forEach((province) => {
        const code = province.code || province.provinceCode || province.id || '';
        const name = (province.name || province.provinceName || '').trim();
        const isMatch = selectedProvince && (selectedProvince === code || selectedProvince.toLowerCase() === name.toLowerCase());
        
        if (isMatch) resolvedProvinceName = name;
        options += `<option value="${name}" data-code="${code}" ${isMatch ? 'selected' : ''}>${name}</option>`;
      });
    }

    provinceDropdown.innerHTML = options;
    provinceDropdown.removeAttribute('disabled');
    provinceDropdown.classList.remove('is-fetching');
    refreshLabels(targetModal);

    if (resolvedProvinceName) {
      updateLabelState(provinceDropdown);
      await getCitiesByProvince(targetModal, resolvedProvinceName);
    } else if (!selectedProvince) {
      resetDropdown(cityDropdown);
      resetDropdown(districtDropdown);
    }
  } catch (err) {
    console.warn('[AddressLog] Error loading provinces:', err);
    provinceDropdown.innerHTML = '<option value="" disabled>Failed to load provinces</option>';
    provinceDropdown.removeAttribute('disabled');
    provinceDropdown.classList.remove('is-fetching');
  } finally {
    setLoadingState(targetModal, false);
  }
}

async function getCitiesByProvince(targetModal, provinceName) {
  const cityDropdown = targetModal.querySelector('select[name="address[city]"]');
  if (!cityDropdown) return;

  const selectedCity = (cityDropdown.dataset.selected || '').trim();
  const districtDropdown = targetModal.querySelector('select[name="address[district]"]');

  setLoadingState(targetModal, true);
  cityDropdown.setAttribute('disabled', 'true');
  cityDropdown.classList.add('is-fetching');
  resetDropdown(districtDropdown);

  try {
    const endpoints = window.API_CONFIG?.ENDPOINTS || {};
    const endpoint = endpoints.ADDRESS_CITIES || '/api/locations/cities';
    
    const res = await fetch(
      `${window.API_CONFIG.BASE_URL}${endpoint}?provinceName=${encodeURIComponent(provinceName)}`,
      {
        method: 'GET',
        headers: window.API_CONFIG?.HEADERS || { 'Content-Type': 'application/json' },
      }
    );

    const json = await res.json();
    const cities = Array.isArray(json) ? json : (json?.data || []);
    let options = '<option value="" selected disabled hidden></option>';
    let resolvedCityName = '';

    if (cities.length === 0) {
      options = '<option value="" disabled>No cities found</option>';
    } else {
      cities.forEach((city) => {
        const cityName = (city.name || city.cityName || '').trim();
        const isMatch = selectedCity && selectedCity.toLowerCase() === cityName.toLowerCase();
        
        if (isMatch) resolvedCityName = cityName;
        options += `<option value="${cityName}" ${isMatch ? 'selected' : ''}>${cityName}</option>`;
      });
    }

    cityDropdown.innerHTML = options;
    cityDropdown.removeAttribute('disabled');
    cityDropdown.classList.remove('is-fetching');
    refreshLabels(targetModal);

    if (resolvedCityName) {
      updateLabelState(cityDropdown);
      await getDistrictsByCity(targetModal, provinceName, resolvedCityName);
    }
  } catch (err) {
    console.warn('[AddressLog] Error fetching cities:', err);
    cityDropdown.innerHTML = '<option value="" disabled>Failed to load cities</option>';
    cityDropdown.removeAttribute('disabled');
    cityDropdown.classList.remove('is-fetching');
  } finally {
    setLoadingState(targetModal, false);
  }
}

async function getDistrictsByCity(targetModal, provinceName, cityName) {
  const districtDropdown = targetModal.querySelector('select[name="address[district]"]');
  if (!districtDropdown) return;

  const selectedDistrict = (districtDropdown.dataset.selected || '').trim();

  setLoadingState(targetModal, true);
  districtDropdown.setAttribute('disabled', 'true');
  districtDropdown.classList.add('is-fetching');

  try {
    const query = new URLSearchParams();
    if (provinceName) query.set('provinceName', provinceName);
    if (cityName) query.set('cityName', cityName);

    const endpoints = window.API_CONFIG?.ENDPOINTS || {};
    const endpoint = endpoints.ADDRESS_DISTRICTS || '/api/locations/districts';

    const res = await fetch(`${window.API_CONFIG.BASE_URL}${endpoint}?${query.toString()}`, {
      method: 'GET',
      headers: window.API_CONFIG?.HEADERS || { 'Content-Type': 'application/json' },
    });

    const json = await res.json();
    const districts = Array.isArray(json) ? json : (json?.data || []);
    let options = '<option value="" selected disabled hidden></option>';

    if (districts.length === 0) {
      options = '<option value="" disabled>No districts found</option>';
    } else {
      districts.forEach((district) => {
        const districtCode = district.code || district.districtCode || '';
        const districtName = (district.name || district.districtName || '').trim();
        const isMatch = selectedDistrict && selectedDistrict.toLowerCase() === districtName.toLowerCase();

        options += `<option value="${districtName}" data-code="${districtCode}" ${isMatch ? 'selected' : ''}>${districtName}</option>`;
      });
    }

    districtDropdown.innerHTML = options;
    districtDropdown.removeAttribute('disabled');
    districtDropdown.classList.remove('is-fetching');
    refreshLabels(targetModal);

    updateLabelState(districtDropdown);
  } catch (err) {
    console.warn('[AddressLog] Error fetching districts:', err);
    districtDropdown.innerHTML = '<option value="" disabled>Failed to load districts</option>';
    districtDropdown.removeAttribute('disabled');
    districtDropdown.classList.remove('is-fetching');
  } finally {
    setLoadingState(targetModal, false);
  }
}

function setLoadingState(targetModal, isLoading) {
  const submitBtn = targetModal.querySelector('button[type="submit"]');
  if (!submitBtn) return;

  targetModal._loadingCount = (targetModal._loadingCount || 0) + (isLoading ? 1 : -1);
  if (targetModal._loadingCount < 0) targetModal._loadingCount = 0;

  if (targetModal._loadingCount > 0) {
    submitBtn.setAttribute('disabled', 'true');
    submitBtn.classList.add('opacity-50', 'cursor-not-allowed');
  } else {
    submitBtn.removeAttribute('disabled');
    submitBtn.classList.remove('opacity-50', 'cursor-not-allowed');
  }
}

function resetDropdown(dropdown) {
  if (!dropdown) return;
  dropdown.innerHTML = '<option value="" selected disabled hidden></option>';
  dropdown.value = '';
  dropdown.setAttribute('disabled', 'true');
  const field = dropdown.closest('.field');
  if (field) {
    field.classList.remove('field--has-value');
    field.classList.remove('field--is-loading');
    field.classList.remove('has-error');
  }
}

function validateAddressForm(form) {
  let isValid = true;
  const nameRegex = /^[A-Za-z0-9\s#\.,\-\/\(\)]+$/;
  const postalRegex = /^[0-9]{4}$/;

  // Clear previous error states
  form.querySelectorAll('.field').forEach(field => field.classList.remove('has-error'));

  const requiredFields = [
    { selector: "input[name='address[first_name]']", message: 'Please enter your First Name.', invalidMessage: 'First Name should not contain special character.', regex: nameRegex, group: "div[data-error-group='firstname']" },
    { selector: "input[name='address[last_name]']", message: 'Please enter your Last Name.', invalidMessage: 'Last Name should not contain special character.', regex: nameRegex, group: "div[data-error-group='lastname']" },
    { selector: "input[name='address[address1]']", message: 'Please enter your Address.', group: "div[data-error-group='address1']" },
    { selector: "select[name='address[city]']", message: 'Please enter your City.', group: "div[data-error-group='city']" },
    { selector: "select[name='address[district]']", message: 'Please enter your District.', group: "div[data-error-group='district']" },
    { selector: "select[name='address[province]']", message: 'Please select your Province.', group: "div[data-error-group='province']" },
    { selector: "input[name='address[zip]']", message: 'Please enter your Postal/ZIP code.', invalidMessage: 'Postal Code must be 4 digits.', regex: postalRegex, group: "div[data-error-group='postal']" }
  ];

  requiredFields.forEach((field) => {
    const input = form.querySelector(field.selector);
    const group = form.querySelector(field.group);
    if (!input) return;

    const existingError = input.closest('.field').nextElementSibling;
    if (existingError && existingError.classList.contains('error-message-field')) {
      existingError.remove();
    }
    input.setAttribute('aria-invalid', 'false');

    if (!input.value.trim()) {
      isValid = false;
      group?.classList.add('has-error');
      input.setAttribute('aria-invalid', 'true');
      const error = document.createElement('div');
      error.classList.add('error-message-field');
      error.innerText = field.message;
      input.closest('.field').insertAdjacentElement('afterend', error);
    } else if (field.regex && !field.regex.test(input.value.trim())) {
      isValid = false;
      group?.classList.add('has-error');
      input.setAttribute('aria-invalid', 'true');
      const error = document.createElement('div');
      error.classList.add('error-message-field');
      error.innerText = field.invalidMessage;
      input.closest('.field').insertAdjacentElement('afterend', error);
    }
  });

  const existingGlobalError = form.querySelector('.global-error-bar');
  if (!isValid) {
    if (!existingGlobalError) {
      const globalErrorBar = document.createElement('div');
      globalErrorBar.classList.add('global-error-bar');
      globalErrorBar.innerText = 'Please correct the invalid fields.';
      const container = form.querySelector('.space-y-4');
      if (container) container.insertBefore(globalErrorBar, form.querySelector('.flex.gap-2.py-8'));
    }
  } else if (existingGlobalError) {
    existingGlobalError.remove();
  }

  return isValid;
}

// Global listener for ALL Address Form Submissions (Add, Edit, Delete, Default)
if (!document._addressGlobalListenerAdded) {
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    const isAddressForm = form.action.includes('/account/addresses');
    if (!isAddressForm || form._isSubmitting || e.defaultPrevented) return;

    // Distinguish between Add/Edit and Delete/Default
    const isDelete = form.querySelector('input[name="_method"][value="delete"]');
    const isDefault = form.querySelector('input[name="address[default]"][value="true"]');
    const isPrimary = form.querySelector('input[name="address[first_name]"]');
    
    if (isDelete || isDefault || isPrimary) {
      e.preventDefault();
      
      // Validation for Add/Edit forms
      if (isPrimary && typeof validateAddressForm === 'function' && !validateAddressForm(form)) {
        return;
      }

      form._isSubmitting = true;
      const submitBtn = form.querySelector('[type="submit"]');
      const originalText = submitBtn ? submitBtn.innerText : '';
      
      if (submitBtn) {
        submitBtn.innerText = 'Processing...';
        submitBtn.setAttribute('disabled', 'true');
      }

      try {
        // 1. Sync metadata
        if (isPrimary && typeof syncAddressMetafields === 'function') {
          // Add/Edit sync
          await syncAddressMetafields(form);
        } else if (isDelete) {
          // Explicit Delete sync
          const addressId = form.action.split('/').pop().split('?')[0];
          const baseUrl = window.API_CONFIG?.BASE_URL || '';
          
          await fetch(`${baseUrl}/api/customer-address-delete`, {
            method: 'POST',
            headers: window.API_CONFIG?.HEADERS || { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              customerId: window.customer?.id || '',
              email: window.customer?.email || '',
              shopifyAddressId: addressId
            })
          });
          console.log('[AddressLog] Metadata entry deleted for:', addressId);
        }

        // 2. Submit main form via AJAX
        await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          redirect: 'manual'
        });

        // 3. Trigger UI Refresh
        window.location.reload();

      } catch (err) {
        console.error('Address action failed:', err);
      } finally {
        form._isSubmitting = false;
        if (submitBtn) {
          submitBtn.innerText = originalText;
          submitBtn.removeAttribute('disabled');
        }
      }
    }
  });
  document._addressGlobalListenerAdded = true;
}

document.addEventListener('DOMContentLoaded', () => {
  initCustomerAddressScripts();
});
